export const GTM_LOADED_EVENT = 'gtm_loaded';
